<template>
  <div :class="`select-container${dropdownSize === 'small' ? ' select-container-sm' : ''}`">
    <label
      v-if="labelSize === 'large'"
      :for="id"
      class="label-lg"
    >{{
      label
    }}</label>
    <label
      v-if="labelSize === 'default'"
      :for="id"
      :class="['select-label-top', isSelected ? 'selected-label-top' : '',disabled ? 'label-top-disabled':'']"
    >{{ label }}</label>
    <select
      :id="id"
      v-model="dropdownValue"
      :name="name"
      :aria-label="ariaLabel || label"
      aria-description="select a value from the list"
      :class="{
        'select-lg': labelSize === 'large',
        selected: isSelected ,
        'is-invalid-input':hasError
      }"
      :disabled="disabled"
      @change="onSelect($event)"
      @blur="handleChange"
    >
      <option
        v-if="disabledOption"
        disabled
        selected
      >
        {{ disabledMessage }}
      </option>
      <option
        v-for="option in options"
        :key="option['value']"
        :value="option['value']"
        :selected="dropdownValue === option['value']"
        :disabled="option.disabled"
        @blur="handleChange"
        @update:modelValue="handleChange"
      >
        {{ option["displayValue"] }}
      </option>
    </select>
  </div>
</template>
<script setup>
import {
  ref, watch, computed,
} from 'vue';
import generateRandomId from '../../utils/randomNumber';

const props = defineProps({
  id: {
    type: [String, Number],
    default: () => generateRandomId(),
  },
  name: {
    type: String,
    default: 'dropdown',
  },
  label: {
    type: String,
    default: 'Dropdown',
  },
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  labelSize: {
    type: String,
    default: 'default',
  },
  dropdownSize: {
    type: String,
    default: 'large',
  },
  disabledOption: {
    type: Boolean,
    default: false,
  },
  disabledMessage: {
    type: String,
    default: 'Select an option',
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: undefined,
  },
});
const emit = defineEmits(['update:modelValue', 'change']);
const dropdownValue = ref(props.modelValue);
const isSelected = computed(() => !!dropdownValue.value?.length);
const onSelect = (event) => {
  emit('update:modelValue', event.target.value);
  emit('change', event);
};
watch(() => props.modelValue, (newValue) => {
  dropdownValue.value = newValue;
});
const handleChange = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<style lang="scss" scoped>
@import "~@core/csg/src/scss/forms/forms.scss";
@include csg-forms;
</style>
